import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "style"];
import getSystem from './getSystem';
import { extendAtomProps, removeAtomsFromProps, filterAllowedAtoms } from './utils';
/**
 * @param {Object} props
 * @param {Array} allowed
 *
 * @returns - [className, style, restProps]
 *
 * @example
 * const [className, style, rest] = system({ m: 3, p: 2 }, ['marginProps']); // Will only return margin3 as className
 */

var system = function system(props, allowed) {
  var allowedAtoms = extendAtomProps(allowed);
  var atomProps = filterAllowedAtoms(props, allowedAtoms);

  var _removeAtomsFromProps = removeAtomsFromProps(props, allowedAtoms),
      className = _removeAtomsFromProps.className,
      style = _removeAtomsFromProps.style,
      rest = _objectWithoutPropertiesLoose(_removeAtomsFromProps, _excluded);

  var _getSystem = getSystem(_extends({}, atomProps, {
    className: className,
    style: style
  })),
      systemClassName = _getSystem[0],
      systemStyle = _getSystem[1];

  return [systemClassName, systemStyle, rest];
};

export default system;